<template>
  <div>
    <div style="margin-bottom: 16px">
      <el-button class="mwow-button-filled success" @click="handleAddCourse"
        >添加课程</el-button
      >
      <!-- <el-button class="mwow-button-filled">删除</el-button> -->
    </div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleResetSearch">
      <el-form size="mini" :model="searchInfo" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="课程搜索:" prop="course_name">
              <el-input
                placeholder="请输入课程名称"
                v-model="searchInfo.course_name"
                maxlength="100"
                @change="handleSearchCourse"
                @clear="handleSearchCourse"
                prefix-icon="el-icon-search"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="科目:" prop="subject_id">
              <el-select
                v-model="searchInfo.subject_id"
                placeholder="请选择"
                @change="handleSearchCourse"
                @focus="handleGetSubjectList"
              >
                <el-option
                  v-for="item in subjectsList"
                  :key="item.subject_id"
                  :label="item.subject_title"
                  :value="item.subject_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="线下购买:" prop="sales_status">
              <el-radio-group
                v-model="searchInfo.sales_status"
                @change="handleSearchCourse"
              >
                <el-radio-button :label="-1">不限</el-radio-button>
                <el-radio-button :label="1">开启</el-radio-button>
                <el-radio-button :label="2">关闭</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="售卖方式:" prop="sell_type">
              <el-radio-group
                v-model="searchInfo.sell_type"
                @change="handleSearchCourse"
              >
                <el-radio-button :label="-1">不限</el-radio-button>
                <el-radio-button :label="1">自定义</el-radio-button>
                <el-radio-button :label="2">课包</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <!-- <el-table-column type="selection" width="50" align="center">
      </el-table-column> -->
      <el-table-column label="排序" prop="sort" width="120">
        <template slot-scope="scope">
          <sort-editor
            type="course"
            :id="scope.row.course_id"
            :ori="scope.row.sort"
          ></sort-editor>
        </template>
      </el-table-column>
      <el-table-column label="科目" prop="subject_name"></el-table-column>
      <el-table-column label="课程名称" prop="course_name"></el-table-column>
      <el-table-column label="课程类型" prop="course_type">
        <template slot-scope="scope">{{
          scope.row.course_type === 1 ? "1vN" : "1v1"
        }}</template>
      </el-table-column>
      <el-table-column label="售卖方式" prop="sell_type">
        <template slot-scope="scope"
          >{{ scope.row.sell_type === 1 ? "自定义" : "课包" }}
        </template>
      </el-table-column>
      <el-table-column label="课包类型" prop="package_type">
        <template slot-scope="scope">{{
          scope.row.package_type === 1 ? "普通课包" : "时间课包"
        }}</template>
      </el-table-column>
      <el-table-column label="在读学员" prop="student_count"></el-table-column>
      <el-table-column label="线下购买" prop="sales_status">
        <template slot-scope="scope">
          <el-switch
            @click.native="() => confirmSetStatus(scope.row)"
            v-model="scope.row.sales_status"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="是否显示" prop="is_show">
        <template slot-scope="scope">
          <el-switch
            @change="setCourseVisible(scope.row)"
            v-model="scope.row.is_show"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="160" align="center">
        <template slot-scope="scope">
          <el-button class="mwow-button success" @click="toDetail(scope.row)"
            >编辑</el-button
          >
          <el-button class="mwow-button info" @click="confirmDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import {
  courseList,
  deleteCourse,
  setCourseStatus,
  setRelateCourse,
  checkCourseStudent,
  setCourseVisibleApi,
} from "@/api/course";
import { subjectList } from "@/api/subject";
import sortEditor from "./sortEditor.vue";
import { PageModule } from "@/store/module/page";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  props: ["visible"],
  components: {
    sortEditor,
    CommonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        course_name: "",
        subject_id: "",
        sales_status: -1,
        sell_type: -1,
      },
      courseList: [],
      subjectsList: [],
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  created() {
    const cache = PageModule.pageInfo.storeCourse;
    if (cache.pagec) {
      this.page = cache.pagec;
    }
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.getList({
          page: this.page,
          page_size: this.pageSize,
        });
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    }
  },
  methods: {
    handleResetSearch() {
      this.searchInfo = {
        course_name: "",
        subject_id: "",
        sales_status: -1,
      };
      this.handleSearchCourse();
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.course_name) {
        option.course_name = this.searchInfo.course_name;
      }
      if (this.searchInfo.subject_id >= 0) {
        option.subject_id = this.searchInfo.subject_id;
      }
      if (this.searchInfo.sales_status >= 0) {
        option.sales_status = this.searchInfo.sales_status;
      }
      if (this.searchInfo.sell_type >= 0) {
        option.sell_type = this.searchInfo.sell_type;
      }
      courseList(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((item) => {
            item.sales_status = item.sales_status === 1;
            item.is_show = item.is_show === 1;
          });
          this.tableData = res.data.list;
          this.page = params.page;
          this.total = res.data.total;
        }
      });
    },
    handleGetSubjectList() {
      if (this.subjectsList.length > 0) {
        return false;
      }
      subjectList({
        page: 1,
        page_size: 100,
      }).then((res) => {
        if (res.error_code === 0) {
          this.subjectsList = [...res.data.list];
        }
      });
    },
    handleAddCourse() {
      this.$router.push({
        name: "storeCourseDetail",
        query: {
          id: "0",
        },
      });
    },
    handleSearchCourse() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    toDetail(row) {
      this.$router.push({
        name: "storeCourseDetail",
        query: {
          id: row.course_id,
          type: "1",
        },
      });
    },
    confirmDelete(row) {
      checkCourseStudent({ course_id: row.course_id }).then((res) => {
        if (res.error_code === 0) {
          if (res.data.list.length > 0) {
            let str = "";
            res.data.list.map((item) => {
              str = str + item.name + "、";
            });
            str = str.replace(/.$/, "");
            this.$alert(
              `以下学员结课后，才能删除。${str}`,
              `删除 - ${row.course_name}`,
              {
                confirmButtonText: "关闭",
                confirmButtonClass: "mwow-button-filled mini",
                type: "warning",
                iconClass: "mwow-icon-error",
              }
            );
          } else {
            this.$confirm(
              `删除后，课程的所有数据不能恢复，同时涉及到该课程的点名签到也无法进行。`,
              `删除 - ${row.course_name}`,
              {
                confirmButtonText: "确定",
                confirmButtonClass: "mwow-button-filled success mini",
                cancelButtonText: "取消",
                cancelButtonClass: "mwow-button-filled mini",
                iconClass: "mwow-icon-error",
              }
            )
              .then(() => {
                this.handleDelete(row.course_id);
              })
              .catch(() => {});
          }
        }
      });
    },
    handleDelete(cid) {
      deleteCourse({ course_id: cid }).then((res) => {
        if (res.error_code == 0) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.handleRefresh("delete");
        } else {
          this.$message({
            type: "error",
            message: "删除失败!" + res.message,
          });
        }
      });
    },
    confirmSetStatus(row) {
      if (!row.sales_status) {
        setRelateCourse({ course_id: row.course_id }).then((result) => {
          if (result.error_code === 0) {
            let str = "";
            result.data.list.map((i) => {
              str = str + i.combo_product_name + "、";
            });
            str = str.replace(/.$/, "");
            if (str) {
              const title = `关闭购买 - ${row.course_name}`;
              const content = `停止购买此课程后，以下包含此课程的套餐都将停止购买。${str}`;
              this.$confirm(content, title, {
                confirmButtonText: "确定",
                confirmButtonClass: "mwow-button-filled success mini",
                cancelButtonText: "取消",
                cancelButtonClass: "mwow-button-filled mini",
                type: "warning",
              })
                .then(() => {
                  this.handleSetStatus(row.course_id, 2);
                })
                .catch(() => {
                  this.getList({
                    page: this.page,
                    page_size: this.pageSize,
                  });
                });
            } else {
              this.handleSetStatus(row.course_id, 2);
            }
          }
        });
      } else {
        this.handleSetStatus(row.course_id, 1);
      }
    },
    handleSetStatus(cid, status) {
      setCourseStatus({
        course_id: cid,
        sales_status: status,
      }).then((res) => {
        if (res.error_code == 0) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
        } else {
          this.$message({
            type: "error",
            message: "修改失败!" + res.message,
          });
        }
      });
    },
    setCourseVisible(row) {
      setCourseVisibleApi({
        course_id: row.course_id,
        is_show: row.is_show ? 1 : 2,
      })
        .then((res) => {
          if (res.error_code == 0) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          } else {
            this.$message({
              type: "error",
              message: "修改失败!" + res.message,
            });
          }
        })
        .catch(() => {
          this.getList({
            page: this.page,
            page_size: this.pageSize,
          });
        });
    },
    handleRefresh(type) {
      let page = this.page;
      if (
        type === "delete" &&
        (this.page - 1) * this.pageSize + 1 === this.total
      ) {
        page = page - 1;
      }
      this.getList({
        page: page > 0 ? page : 1,
        page_size: this.pageSize,
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
      PageModule.SET_PAGE_INFO({
        name: "storeCourse",
        key: "pagec",
        value: e,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
